import { CreateFormDialog, UpdateFormDialog } from "./Atom"

const CreateUpdateContractModal = (props: any) => {
  const { open, createHandler, updateHandler, closeHandler, type } = props

  if (type == "edit") {
    return (
      <UpdateFormDialog
        open={open}
        closeHandler={closeHandler}
        updateHandler={updateHandler}
      />
    )
  }

  return (
    <CreateFormDialog
      open={open}
      closeHandler={closeHandler}
      createHandler={createHandler}
    />
  )
}

export default CreateUpdateContractModal
